import { getFieldType } from './fieldTypeRegistry.jsx';
import { KEYWORD_FIELD_TYPE, normalizeKeywordValue } from './keywordCriteria';

// Which two query params a composite control fills on the traditional list
// endpoint. Configurable because param names differ per module; the default
// covers the usual `<field>From` / `<field>To` pair.
export function rangeKeysFor(field) {
  if (Array.isArray(field.rangeKeys) && field.rangeKeys.length === 2) return field.rangeKeys;
  return [`${field.field}From`, `${field.field}To`];
}

// GET /module-data-list takes flat params, so a positional tuple ([from, to])
// has to be split. A multi-select's list of chips is left alone — that is one
// param the list endpoint already understands.
export function buildTraditionalParams(values = {}, fields = []) {
  const params = { ...values };

  fields.forEach((field) => {
    const type = field.type ?? 'text';

    // Sent via the generic `filters` mechanism instead (buildFilterConditions)
    // — its {preset,from,to} object has no flat-param representation, so it
    // must not reach the flatten-everything loop in searchModuleData.
    if (type === 'daterangePreset') {
      delete params[field.field];
      return;
    }

    // Starred chips travel as the structured `keywordGroups` parameter, and
    // their { terms, expression } value has no flat representation at all —
    // left in, it would flatten to "[object Object]". The flat param a
    // converted field still needs is written by buildBooleanRequest, which
    // knows which chips are mandatory; here it can only be removed.
    if (type === KEYWORD_FIELD_TYPE) {
      const model = normalizeKeywordValue(values[field.field]);
      const terms = model.terms.map((term) => term.value);
      if (terms.length) params[field.field] = terms;
      else delete params[field.field];
      return;
    }

    if (!getFieldType(type).multiValue) return;
    if (type !== 'range' && type !== 'daterange') return;

    const raw = values[field.field];
    if (!Array.isArray(raw)) return;

    const [fromKey, toKey] = rangeKeysFor(field);
    delete params[field.field];

    const [from, to] = raw;
    if (from !== undefined && from !== null && from !== '') params[fromKey] = from;
    if (to !== undefined && to !== null && to !== '') params[toKey] = to;
  });

  return params;
}
